import ko from "knockout";
import register from "flow/knockout/register";

type Info = { hasInfo: boolean; infoMessage: string };

interface IInfoObservable extends KnockoutObservable<any> {
    hasInfo: KnockoutObservable<boolean>;
    infoMessage: KnockoutObservable<string>;
}

register.registerKnockoutExtension("info", function (target: IInfoObservable, infoFunction: (data: any) => Info) {
    //add some sub-observables to our observable
    target.hasInfo = ko.observable<boolean>();
    target.infoMessage = ko.observable<string>();

    //define a function wrapper to call validation function
    ko.computed(function () {
        const result = infoFunction(target());

        target.hasInfo(result.hasInfo);
        target.infoMessage(result.infoMessage);
    });

    //return the original observable
    return target;
});
